import React from 'react'
import {withStyles} from 'material-ui/styles'
import Button from 'material-ui/Button'
import PropTypes from 'prop-types'

import {login as text} from '../text'

const styles = () => ({
  button: {
    height: 60,
  }
})

const Login = ({classes, goSignup, goLogin}) => (
  <div>
    <Button className={classes.button}  onClick={goLogin}>
      {text.button}
    </Button>
  </div>
)

Login.propTypes = {
  goSignup: PropTypes.func.isRequired,
  goLogin: PropTypes.func.isRequired,
}

export default withStyles(styles)(Login)



// WEBPACK FOOTER //
// ./src/sections/header/components/login.js